<template>
  <v-dialog v-model="showModal" width="500" @click:outside=closeDialog>
      <v-card max-width="500">
        <v-card-title class="d-flex justify-space-between align-center">
          <div class="text-h5 text-medium-emphasis ps-2 title-text">{{ isEdit ? 'edit quote' : 'add quote' }}</div>
          <v-btn icon="mdi-close" variant="text" @click=closeDialog></v-btn>
        </v-card-title>
        <v-divider class="mb-4"></v-divider>
        <v-card-text>
          <v-sheet class="mx-auto" width="400">
            <v-form @submit.prevent ref="form">
              <v-textarea v-model="quote_text" id="quote_text" :rules="[required]" label="quote" variant="underlined" class="form_field" rows="3"></v-textarea>
              <v-text-field v-model="author" id="author" :rules="[required]" label="author" variant="underlined" class="form_field"></v-text-field>
            </v-form>
          </v-sheet>
        </v-card-text>
        <template v-slot:actions>
          <v-btn v-if="isEdit" v-on:click="deleteQuote" class="mt-2 submit_button" color="error" variant="text">Delete</v-btn>
          <v-spacer></v-spacer>
          <v-btn v-on:click="submitForm" class="mt-2 submit_button" type="submit" :block="!isEdit">Submit</v-btn>
        </template>
      </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import { mapState, mapMutations} from 'vuex';

export default {
  props: {
    show: Boolean,
    currentRow: Object
  },
  data() {
    return {
      quote_text: '',
      author: ''
    }
  },
  computed: {
    ...mapState({
      token: "token"
    }),
    showModal: {
      get () {
        return this.show
      }
    },
    isEdit() {
      return this.currentRow && this.currentRow.id;
    }
  },
  watch: {
    show(val) {
      if (val && this.currentRow && this.currentRow.id) {
        this.quote_text = this.currentRow.quote_text;
        this.author = this.currentRow.author;
      }
    }
  },
  methods: {
      ...mapMutations(["showSnackbar"]),
    async submitForm(e) {
      e.preventDefault();
      const { valid } = await this.$refs.form.validate();
      if (!valid) return;
      try {
        if (this.isEdit) {
          await axios.request({
            url: `/quotes/${this.currentRow.id}`,
            method: "PUT",
            headers: { Authorization: `Bearer ${this.token}` },
            data: { quote_text: this.quote_text, author: this.author }
          });
        } else {
          await axios.request({
            url: "/quotes/",
            method: "POST",
            headers: { Authorization: `Bearer ${this.token}` },
            data: { quote_text: this.quote_text, author: this.author }
          });
        }
        this.resetDataValues();
        this.$parent.getQuotes();
        this.$emit("close");
      } catch (error) {
        this.showSnackbar({ message: 'Failed to save quote' });
      }
    },
    async deleteQuote() {
      try {
        await axios.request({
          url: `/quotes/${this.currentRow.id}`,
          method: "DELETE",
          headers: { Authorization: `Bearer ${this.token}` }
        });
        this.resetDataValues();
        this.$parent.getQuotes();
        this.$emit("close");
      } catch (error) {
        this.showSnackbar({ message: 'Failed to delete quote' });
      }
    },
    closeDialog(){
      this.resetDataValues();
      this.$emit('close');
    },
    resetDataValues(){
      this.quote_text = "";
      this.author = "";
    },
    required (v) {
        return (v !== null && v !== undefined && v !== '') || 'required'
    },
  }
}
</script>

<style scoped>

.title-text, .body-text, .form_field, .submit_button {
  font-family: "Space Grotesk", "Courier New", Courier, monospace, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

</style>
